import "./ItemCourseInProposal.scss";

import React from "react";
import { images } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  removeCoursesFromProposal,
  removeUpdatingCourseAdded,
  setCourseUpdatingInProposal,
  updatingCourseAdded,
} from "../../actions/proposal";
import { capitalize } from "../../helper/capitalize";
import { openModal } from "../../actions/ui";
import ModalProposal from "../Modals/ModalProposal";
import ProposalCoursesSelectEditing from "../Proposals/ProposalCoursesSelectEditing";
import { numberNotation } from "../../helper/numberStructure";

const ItemCourseInProposal = ({ course }) => {
  const dispatch = useDispatch();

  const { modalOpen } = useSelector((state) => state.ui);
  const { updatingCourse } = useSelector((state) => state.proposals);

  const handleEditItem = (course) => {
    dispatch(openModal());
    dispatch(updatingCourseAdded());
    dispatch(setCourseUpdatingInProposal(course));
  };
  const handleRemoveItem = (courseId) => {
    dispatch(removeCoursesFromProposal(courseId));
  };
  return (
    <div className="item-course-proposal">
      <div className="item-course-proposal__wrapper">
        <div className="item-course-proposal__heading">
          <div className="item-course-proposal__heading-main">
            <div className="item-course-proposal__heading--image">
              <img src={images.IconCourseR} alt="" />
            </div>

            <div className="item-course-proposal__heading--name">
              <h2 className="title-gray-black-18">{course.name}</h2>
              <h2 className="paragraph-gray-reg-14">
                by {course.college.name}
              </h2>
            </div>
          </div>

          <div className="item-course-proposal__heading--buttons">
            <button onClick={() => handleEditItem(course)}>
              <img src={images.IconEdit} alt="" />
            </button>
            <button onClick={() => handleRemoveItem(course._id)}>
              <img src={images.IconDelete} alt="" />
            </button>
          </div>
        </div>
        <div className="item-course-proposal__info">
          <span className="title-gray-bold-26 info-item-1">
            A$ {numberNotation(course.total)}
          </span>

          <span className="title-gray-bold-14 info-item-2">
            A$ {numberNotation(course.tuitionfee)}
          </span>
          <span className="paragraph-gray-reg-14 info-item-3">Tuition</span>

          <span className="title-gray-bold-14 info-item-4">
            A$ {numberNotation(course.applicationfee)}
          </span>
          <span className="paragraph-gray-reg-14 info-item-5">Appl.</span>

          <span className="title-gray-bold-14 info-item-6">
            A$ {numberNotation(course.material)}
          </span>
          <span className="paragraph-gray-reg-14 info-item-7">Material</span>

          <span className="title-gray-bold-14 info-item-8">
            A$ {numberNotation(course.firstPayment)}
          </span>
          <span className="paragraph-gray-reg-14 info-item-9">
            First Payment
          </span>

          <span className="paragraph-gray-reg-14 info-item-10 js-center">
            Duration(weeks)
          </span>
          <span className="title-gray-bold-14 info-item-11 js-end">
            {course.duration}
          </span>
          <span className="paragraph-gray-reg-14 info-item-12 js-center">
            Campus
          </span>
          <span className="title-gray-bold-14 info-item-13 js-end">
            {capitalize(course.campus)}
          </span>
          <span className="paragraph-gray-reg-14 info-item-14 js-center">
            {" "}
            Start{" "}
          </span>
          <span className="title-gray-bold-14 info-item-15 js-end">
            {course.startDate}
          </span>
          <span className="paragraph-gray-reg-14 info-item-16 js-center">
            End{" "}
          </span>
          <span className="title-gray-bold-14 info-item-17 js-end">
            {course.endDate}
          </span>
          <span className="paragraph-gray-reg-14 info-item-18 js-center">
            Payment date{" "}
          </span>
          <span className="title-gray-bold-14 info-item-19 js-end">
            {course.dateFirstPayment}
          </span>
        </div>
      </div>
      {modalOpen && updatingCourse && (
        <ModalProposal clean={removeUpdatingCourseAdded}>
          <ProposalCoursesSelectEditing />
        </ModalProposal>
      )}
    </div>
  );
};

export default ItemCourseInProposal;
